import { useEffect, useState } from 'react';
import { useDisclose } from './useDisclose';
export const useInitialDisclose = (props = {}) => {
  const {
    open,
    onClose,
    onOpen,
    onToggle
  } = useDisclose(props);
  const [initialOpenDone, setInitialOpenDone] = useState(false);
  useEffect(() => {
    if (!initialOpenDone && open) {
      setInitialOpenDone(true);
    }
  }, [initialOpenDone, open]);
  return {
    open,
    onClose,
    onOpen,
    onToggle,
    initialOpenDone
  };
};
//# sourceMappingURL=useInitialDisclose.js.map